module.exports = __webpack_public_path__ + "static/media/AlertNew.43ab4df5.mp3";